import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const pageBannerCSS = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `${vars.spacing[4]} ${vars.spacing[6]}`,

  borderRadius: vars.rounded.large,
});

const _default = css({
  backgroundColor: vars.semantic.color.surfaceSlateSecondary,
});

const critical = css({
  backgroundColor: vars.semantic.color.surfaceCriticalSecondary,
});

const warning = css({
  backgroundColor: vars.semantic.color.surfaceWarningSecondary,
});

const information = css({
  backgroundColor: vars.semantic.color.surfaceHighlightSecondary,
});

export const variantStyle = {
  default: _default,
  critical,
  warning,
  information,
};
